import R from 'ramda';

import buildContent from '../utils';
import tabTemplate from './tab.tpl.html';

export class Tab {
  constructor($scope, $ngRedux, actionsFactory, $translate) {
    Object.assign(this, {
      $scope,
      $ngRedux,
      actionsFactory,
      $translate,
    });
  }

  $onInit() {
    this.mapIndexed = R.addIndex(R.map);
    this.data = this.mapIndexed((item, index) => Object.assign({}, item, { id: index }), this.data);
    this.selectedTab = R.head(this.data);
  }

  selectTab(tab) {
    this.selectedTab = tab;
  }

  isTabSelected(tab) {
    return this.selectedTab && this.selectedTab.id === tab.id;
  }

  isEditMode() {
    return !R.isNil(this.editMode) && this.editMode;
  }

  getLabel(tab, getTooltip = false) {
    const fieldGroupItemTemplate = R.find(
      R.propEq('type', 'field'),
      R.values(this.template.contiguousItemsWithSameType));
    const fieldsHeaderTemplate = R.filter(
      R.pathEq(['attrs', 'header'], true),
      (fieldGroupItemTemplate && fieldGroupItemTemplate.items) || []);

    if (R.isEmpty(fieldsHeaderTemplate)) {
      const fieldItemTemplate = R.head(
        (fieldGroupItemTemplate && fieldGroupItemTemplate.items) || []);

      return !fieldItemTemplate || !tab.fields[fieldItemTemplate.id] ||
        !tab.fields[fieldItemTemplate.id].value
        ? '-'
        : tab.fields[fieldItemTemplate.id].value;
    }

    let tabLabel = fieldsHeaderTemplate
      .map(field => (tab.fields[field.id] && tab.fields[field.id].value) || null)
      .filter(value => !R.isNil(value))
      .map(value => R.trim(value))
      .join(' - ');

    if (getTooltip) {
      const fieldItemTemplate = R.head(
        (fieldGroupItemTemplate && fieldGroupItemTemplate.items) || []);

      const hasTooltip = R.has('tooltip');

      if (hasTooltip(fieldItemTemplate.attrs)) {
        tabLabel = this.$translate.instant(fieldItemTemplate.attrs.tooltip);
      } else {
        return false;
      }
    }

    return !R.isEmpty(tabLabel)
      ? tabLabel
      : '-';
  }

  checkLabel(tab) {
    const fieldGroupItemTemplate = R.find(
      R.propEq('type', 'field'),
      R.values(this.template.contiguousItemsWithSameType));
    const fieldsHeaderTemplate = R.filter(
      R.pathEq(['attrs', 'header'], true),
      (fieldGroupItemTemplate && fieldGroupItemTemplate.items) || []);

    if (R.isEmpty(fieldsHeaderTemplate)) {
      return false;
    }

    const tabLabel = fieldsHeaderTemplate
      .map(field => (tab.fields[field.id] && tab.fields[field.id].value) || null)
      .filter(value => !R.isNil(value))
      .map(value => R.trim(value))
      .join(' - ');

    const fieldItemTemplate = R.head(
      (fieldGroupItemTemplate && fieldGroupItemTemplate.items) || []);

    const hasTooltip = R.has('tooltip');
    // WORKAROUND FOR TOOLTIP
    return (hasTooltip(fieldItemTemplate.attrs) && tabLabel === 'FOUND');
  }

  addTab() {
    const content = buildContent(this.template);
    content.id = this.data.length;
    this.data.push(content);
  }

  removeTab(tabIndex) {
    this.data = R.remove(tabIndex, 1, this.data);
    this.data = this.mapIndexed((item, index) => Object.assign({}, item, { id: index }), this.data);
  }
}

Tab.$inject = [
  '$scope',
  '$ngRedux',
  'actionsFactory',
  '$translate',
];

export const tctTab = {
  template: tabTemplate,
  controller: Tab,
  bindings: {
    template: '<',
    data: '=',
    editMode: '<?',
  },
};
